"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendTransactionsApi = void 0;
const createApi_1 = require("../../../helpers/createApi");
const getTemplates = (caller) => () => {
    return caller('/backend/transaction/datalayers').get();
};
exports.backendTransactionsApi = (0, createApi_1.createAPIFactory)({
    getTemplates,
});
//# sourceMappingURL=api.js.map